import { render, staticRenderFns } from "./FormularioCarnaval.vue?vue&type=template&id=bf627a4e&scoped=true&"
import script from "./FormularioCarnaval.vue?vue&type=script&lang=ts&"
export * from "./FormularioCarnaval.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioCarnaval.vue?vue&type=style&index=0&id=bf627a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf627a4e",
  null
  
)

export default component.exports